import matchers from "./matchers";
/**
 * Test if target matches schema values.
 * Schema must be an object with the properties you need to validate.
 * The schema value must be a function (matcher) that will receive
 * the target's value and expect a boolean as result.
 * target: {name:"dds"}
 * schema: {name:(val)=>val==="dds"}
 * report {name:true}
 * @param {Object} target
 * @param {Object} schema object with Matchers.
 * @returns [success, report]
 */
export default function validate(target, schema) {
    if (!matchers.object(target) || !matchers.object(schema)) {
        return [false, {}];
    }

    /**
     * Test all schema matchers over target values
     * and create a new object with same props and setting
     * true|false in the case it pass or not
     */
    try {
        let success = true;
        const result = Object.keys(schema).reduce((report, schemaProp) => {
            const targetValue = target[schemaProp];
            const schemaValue = schema[schemaProp];
            const targetValueIsObject = matchers.object(targetValue);
            const schemaValueIsObject = matchers.object(schemaValue);
            // Nested object with nested matchers
            // start the recursion and merge the results
            if (targetValueIsObject && schemaValueIsObject) {
                const [nestedSuccess, nestedReport] = validate(targetValue, schemaValue);
                report[schemaProp] = nestedReport;
                success = nestedSuccess && success;
            } else {
                if (typeof schemaValue === "function") {
                    const matcherResult = schemaValue(targetValue);
                    report[schemaProp] = matcherResult;
                    success = matcherResult && success;
                } else {
                    report[schemaProp] = false;
                    success = false;
                }
            }
            return report;
        }, {});
        return [success, result];
    } catch (err) {
        console.warn(err.message);
        return [false, {}];
    }
}
